import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../../../../../commons/services/common.service';

@Component({
  selector: 'app-pgm-jours-feries-devis',
  templateUrl: './pgm-jours-feries-devis.component.html',
  styleUrls: ['./pgm-jours-feries-devis.component.css']
})
export class PgmJoursFeriesDevisComponent implements OnInit {
  @Input() tableConfigJoursFeries;
  loadingIndicator: Boolean = false;
  qteSupp: Boolean = false;
  listJourFerie = [];
  templistJourFerie = [];

  @Output() hidefunction = new EventEmitter<any>();
  @Output() validefunction = new EventEmitter<any>();
  constructor(public common: CommonService) { }

  ngOnInit() {
    this.tableConfigJoursFeries = this.tableConfigJoursFeries || [];
    this.getListJourFerie();
  }

  getListJourFerie() {
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 8
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        const data = datas.data || [];
        const list = [];
        data.forEach(jrs => {
          const elem = {
            configJourFerie: {
              jourFerie: jrs,
              travaillerJourFerie: false,
              rattrapageLendemain: true
            },
            jourFerie: jrs
          };
          list.push(elem);
        });
        const listElm = [];
        this.tableConfigJoursFeries.forEach(elt => {
          list.forEach(elem => {
            if (elem.jourFerie && elt.jourFerie && (elem.jourFerie.id === elt.jourFerie.id)) {
              elem.configJourFerie = Object.assign({}, elt.configJourFerie);
            }
          });
        });

        // this.tableConfigJoursFeries = this.tableConfigJoursFeries || list;
        this.listJourFerie = list;
        this.templistJourFerie = list;
        $('#pgmJourFerie').trigger('click');
      }
    });
  }

  checkedAll(event) {
    this.listJourFerie.forEach(elt => {
      elt.configJourFerie.travaillerJourFerie = event.checked;
      if (elt.configJourFerie.travaillerJourFerie) {
        elt.configJourFerie.rattrapageLendemain = false;
      }
    });
  }

  showFiche() {
    this.hidefunction.emit();
  }

  save() {
    this.validefunction.emit(this.listJourFerie);
    this.hidefunction.emit();
  }
}
